import { useEffect } from "react";
import { Megaphone } from "lucide-react";
import { useApi } from "../../lib/useApi";
import { api } from "../../lib/api";
import { ANN_CATEGORY } from "../../lib/commsLabels";
import { fmtDate } from "../../lib/labels";

const Item = ({ a, track }) => {
  useEffect(() => { if (track) { api.post(`/public/announcements/${a.id}/view`).catch(() => {}); } }, [a.id, track]);
  return (
    <div className="rounded-xl border border-blue-100 bg-blue-50/60 p-4" data-testid={`announcement-${a.id}`}>
      <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wide text-blue-700"><Megaphone className="h-3.5 w-3.5" />{a.company_name ? `${a.company_name} · ` : ""}{ANN_CATEGORY[a.category]}</p>
      <p className="mt-1 font-medium text-slate-900">{a.title}</p>
      <p className="mt-1 whitespace-pre-wrap text-sm text-slate-700">{a.body}</p>
      <p className="mt-1 text-xs text-slate-400">Publiée le {fmtDate(a.starts_at, false)}{a.ends_at ? ` · jusqu'au ${fmtDate(a.ends_at, false)}` : ""}</p>
    </div>
  );
};

export default function AnnouncementsFeed({ url, title, track = true, testId = "announcements-feed" }) {
  const { data } = useApi(url);
  if (!data?.length) return null;
  return (
    <div className="space-y-3" data-testid={testId}>
      {title && <p className="font-display font-semibold">{title}</p>}
      {data.map((a) => <Item key={a.id} a={a} track={track} />)}
    </div>
  );
}
